import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  data: [],
  error: null,
  loading: false,
  warehouse: null,
  exportStatus: { loading: false, error: null },
}

const warehouseSlice = createSlice({
  name: "warehouse",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload
    },
    setError(state, action) {
      state.error = action.payload
    },
    setLoading(state, action) {
      state.loading = action.payload
    },
    setWarehouse(state, action) {
      state.warehouse = action.payload
    },
    setExportStatus(state, action) {
      state.exportStatus = {
        loading: action.payload.loading,
        error: action.payload.error,
      }
    },
    resetState(state) {
      state.data = []
      state.error = null
      state.loading = false
      state.warehouse = null
    },
  },
})

export const warehouseAction = warehouseSlice.actions

export default warehouseSlice
